import './TimeFilter.scss';
import React, { useState, useEffect } from 'react';

import {
    Button,
    SelectItem,
    DatePicker,
    DatePickerInput,
    TimePicker,
    TimePickerSelect,
    ContentSwitcher,
    Switch,
    FormGroup,
    RadioButton,
    RadioButtonGroup,

} from 'carbon-components-react';
import { boolean, number, select, text } from '@storybook/addon-knobs';
import moment from 'moment';
import FlyoutMenu from 'common/FlyoutMenu';
import { SettingsAdjust16, CalendarSettings32 } from '@carbon/icons-react';
import { getNewTimeRange } from './TimeFilterUtil';
import i18n from "../../../i18n";

const TimeRange = i18n.t('manageAutomation.TimeRange');

export const IconButton = () => (
    <Button size="sm" renderIcon={SettingsAdjust16} kind="secondary">{TimeRange}</Button>
);

const timeprops = {
    timepicker: () => ({
        pattern: text(
            'Regular expression for the value (pattern in <TimePicker>)',
            '(1[012]|[1-9]):[0-5][0-9](\\s)?'
        ),
        placeholder: text(
            'Placeholder text (placeholder in <TimePicker>)',
            'hh:mm'
        ),
        disabled: boolean('Disabled (disabled in <TimePicker>)', false),
        light: boolean('Light variant (light in <TimePicker>)', false),
        invalid: boolean(
            'Show form validation UI (invalid in <TimePicker>)',
            false
        ),
        invalidText: text(
            'Form validation UI content (invalidText in <TimePicker>)',
            'A valid value is required'
        ),
        maxLength: number('Maximum length (maxLength in <TimePicker>)', 5),
        size: select('Field size (size)', sizes, undefined) || undefined,
        /* onClick: action('onClick'),
         onChange: action('onChange'),
         onBlur: action('onBlur'),*/
    }),
    select: () => ({
        disabled: boolean('Disabled (disabled in <TimePickerSelect>)', false),
        labelText: text(
            'Label text (labelText in <TimePickerSelect>)',
            'Please select'
        ),
        iconDescription: text(
            'Trigger icon description (iconDescription in <TimePickerSelect>)',
            'open list of options'
        ),
    }),
};
const sizes = {
    'Extra large size (xl)': 'xl',
    'Default size': undefined,
    'Small size (sm)': 'sm',
};


const TimeFilter = props => {

    const [timeFilterSelections, setTimeFilterSelections] = useState(props.timeFilterSelections);
    const [timeRefreshIndex, setTimeRefreshIndex] = useState(0);
    const [timeFilterIndex, setTimeFilterIndex] = useState(0);
    const [timeRefreshContentShow1, setTimeRefreshContentShow1] = useState(true);
    const [timeRefreshContentShow2, setTimeRefreshContentShow2] = useState(false);
    const [timeFilterContentShow1, setTimeFilterContentShow1] = useState(true);
    const [timeFilterContentShow2, setTimeFilterContentShow2] = useState(false);
    const [MinEndDate, setMinEndDate] = useState(props.timeFilterSelections.startDate);
    const [validEndDate, setValidEndDate] = useState(false);
    const [validStartDate, setValidStartDate] = useState(false);
    const [validEndTime, setValidEndTime] = useState(false);
    const Time = i18n.t('manageAutomation.Time');
    const Filter = i18n.t('manageAutomation.Filter');
    const Apply = i18n.t('manageAutomation.Apply');
    const Cancel = i18n.t('manageAutomation.Cancel');
    const tillDate = i18n.t('manageAutomation.tillDate');
    const Custom = i18n.t('manageAutomation.Custom');
    const Refresh = i18n.t('manageAutomation.Refresh');
    const StartDate = i18n.t('manageAutomation.StartDate');
    const StartTime = i18n.t('manageAutomation.StartTime');
    const EndDate = i18n.t('manageAutomation.EndDate');
    const EndTime = i18n.t('manageAutomation.EndTime');
    const startTimeErrorMessage = i18n.t('manageAutomation.StartTimeErrorMessage');
    const endTimeErrorMessage = validEndDate ? i18n.t('manageAutomation.endTimeErrorMessage') : i18n.t('manageAutomation.endTimeFutureErrorMessage');

    useEffect(() => {
        setTimeFilterSelections(props.timeFilterSelections);
    }, [props]);

    useEffect(() => {
        if (timeFilterSelections.startDate !== props.timeFilterSelections.startDate && timeFilterSelections.startDate !== '') {
            setMinEndDate(timeFilterSelections.startDate)
        }
        else if (timeFilterSelections.startDate !== '') {
            setMinEndDate(props.timeFilterSelections.startDate)
        }
    }, [MinEndDate, timeFilterSelections.startDate, props.timeFilterSelections])

    const handleFilterChange = () => {
        setTimeRefreshIndex(0);
        setTimeFilterIndex(0);
        handleTimeFilterToggle({ index: 0 });
        handleTimeRefreshToggle({ index: 0 });
        props.updateState('timeFilterSelections', timeFilterSelections);
    }
    const handleFilterCancel = () => {
        setTimeRefreshIndex(0);
        setTimeFilterIndex(0);
        handleTimeFilterToggle({ index: 0 });
        handleTimeRefreshToggle({ index: 0 });
    }


    const handleTimeButtonClick = (time) => {
        let selections = getNewTimeRange(time);
        setTimeFilterSelections({
            ...timeFilterSelections, "startDateTime": selections.startDateTime, "startDate": selections.startDate, "startTime": selections.startTime, "startAMPM": selections.startAMPM,
            "endDateTime": selections.endDateTime, "endDate": selections.endDate, "endTime": selections.endTime, "endAMPM": selections.endAMPM, "timeRange": selections.timeRange, "timeRangeType": selections.timeRangeType
        });
        //clearing error messages for preselected values::start
        setValidEndDate(false);
        setValidStartDate(false);
        setValidEndTime(false);
        //end
    };

    const handleTimeChange = (element, e) => {
        var filterMoment = null;
        let StartDateTime, EndDatetime, MStart, MEnd, Valid, ValidCurrentDate, MCurrent, ValidCurrentEndDate;
        MCurrent = moment(new Date()).format();
        switch (element) {
            case 'startDate':
                filterMoment = moment(e[0]);
                var startDateTimeMoment = moment(filterMoment.format('l') + " " + timeFilterSelections.startTime + " " + timeFilterSelections.startAMPM);
                setTimeFilterSelections({
                    ...timeFilterSelections, "startDate": filterMoment.format('l'), "startDateTime": startDateTimeMoment.format(), "timeRangeType": "absolute"

                });
                StartDateTime = startDateTimeMoment.format();
                EndDatetime = timeFilterSelections.endDateTime;
                MStart = moment(StartDateTime);
                MEnd = moment(EndDatetime).seconds(0);
                if (timeFilterSelections.endDateTime !== '') {
                    Valid = MStart.isBefore(MEnd);
                    ValidCurrentDate = MStart.isBefore(MCurrent);
                    ValidCurrentDate ? setValidStartDate(false) : setValidStartDate(true);
                    Valid ? setValidEndDate(false) : setValidEndDate(true);
                }
                break;
            case 'endDate':
                filterMoment = moment(e[0]);
                var endDateTimeMoment = moment(filterMoment.format('l') + " " + timeFilterSelections.endTime + " " + timeFilterSelections.endAMPM);
                setTimeFilterSelections({
                    ...timeFilterSelections, "endDate": filterMoment.format('l'), "endDateTime": endDateTimeMoment.format(), "timeRangeType": "absolute"
                });
                StartDateTime = timeFilterSelections.startDateTime;
                EndDatetime = endDateTimeMoment.format();
                MStart = moment(StartDateTime).seconds(0);
                MEnd = moment(EndDatetime);
                if (timeFilterSelections.startDateTime !== '') {
                    Valid = MStart.isBefore(MEnd);
                    ValidCurrentEndDate = MEnd.isBefore(MCurrent);
                    ValidCurrentEndDate ? setValidEndTime(false) : setValidEndTime(true);
                    Valid ? setValidEndDate(false) : setValidEndDate(true);
                }
                break;
            case 'startTime':
                var startDateTimeMoment = moment(timeFilterSelections.startDate + " " + e.target.value + " " + timeFilterSelections.startAMPM);
                setTimeFilterSelections({
                    ...timeFilterSelections, "startTime": e.target.value, "startDateTime": startDateTimeMoment.format(), "timeRangeType": "absolute"
                });
                StartDateTime = startDateTimeMoment.format();
                EndDatetime = timeFilterSelections.endDateTime;
                MStart = moment(StartDateTime);
                MEnd = moment(EndDatetime).seconds(0);
                if (timeFilterSelections.endDateTime !== '') {
                    Valid = MStart.isBefore(MEnd);
                    ValidCurrentDate = MStart.isBefore(MCurrent);
                    ValidCurrentDate ? setValidStartDate(false) : setValidStartDate(true);
                    Valid ? setValidEndDate(false) : setValidEndDate(true);
                }
                break;
            case 'endTime':
                var endDateTimeMoment = moment(timeFilterSelections.endDate + " " + e.target.value + " " + timeFilterSelections.endAMPM);
                setTimeFilterSelections({
                    ...timeFilterSelections, "endTime": e.target.value, "endDateTime": endDateTimeMoment.format(), "timeRangeType": "absolute"
                });
                StartDateTime = timeFilterSelections.startDateTime;
                EndDatetime = endDateTimeMoment.format();
                MStart = moment(StartDateTime).seconds(0);
                MEnd = moment(EndDatetime);
                if (timeFilterSelections.startDateTime !== '') {
                    Valid = MStart.isBefore(MEnd);
                    ValidCurrentEndDate = MEnd.isBefore(MCurrent);
                    ValidCurrentEndDate ? setValidEndTime(false) : setValidEndTime(true);
                    Valid ? setValidEndDate(false) : setValidEndDate(true);
                }
                break;
            case 'startAMPM':
                var startDateTimeMoment = moment(timeFilterSelections.startDate + " " + timeFilterSelections.startTime + " " + e.target.value);
                setTimeFilterSelections({
                    ...timeFilterSelections, "startAMPM": e.target.value, "startDateTime": startDateTimeMoment.format(), "timeRangeType": "absolute"
                });
                StartDateTime = startDateTimeMoment.format();
                EndDatetime = timeFilterSelections.endDateTime;
                MStart = moment(StartDateTime);
                MEnd = moment(EndDatetime).seconds(0);
                if (timeFilterSelections.endDateTime !== '') {
                    Valid = MStart.isBefore(MEnd);
                    ValidCurrentDate = MStart.isBefore(MCurrent);
                    ValidCurrentDate ? setValidStartDate(false) : setValidStartDate(true);
                    Valid ? setValidEndDate(false) : setValidEndDate(true);
                }
                break;
            case 'endAMPM':
                var endDateTimeMoment = moment(timeFilterSelections.endDate + " " + timeFilterSelections.endTime + " " + e.target.value);
                setTimeFilterSelections({
                    ...timeFilterSelections, "endAMPM": e.target.value, "endDateTime": endDateTimeMoment.format(), "timeRangeType": "absolute"
                });
                StartDateTime = timeFilterSelections.startDateTime;
                EndDatetime = endDateTimeMoment.format();
                MStart = moment(StartDateTime).seconds(0);
                MEnd = moment(EndDatetime);
                if (timeFilterSelections.startDateTime !== '') {
                    Valid = MStart.isBefore(MEnd);
                    ValidCurrentEndDate = MEnd.isBefore(MCurrent);
                    ValidCurrentEndDate ? setValidEndTime(false) : setValidEndTime(true);
                    Valid ? setValidEndDate(false) : setValidEndDate(true);
                    break;
                }
            default:
        }
    }
    const handleTimeFilterToggle = (obj) => {
        setTimeFilterIndex(obj.index);
        if (obj.index === 0) {
            setTimeFilterContentShow1(true);
            setTimeFilterContentShow2(false);
        } else {
            setTimeFilterContentShow1(false);
            setTimeFilterContentShow2(true);
        }
    };
    const handleTimeRefreshToggle = (obj) => {
        setTimeRefreshIndex(obj.index);
        if (obj.index === 0) {
            setTimeRefreshContentShow1(true);
            setTimeRefreshContentShow2(false);
        } else {
            setTimeRefreshContentShow1(false);
            setTimeRefreshContentShow2(true);
        }
    };

    const updateRefresh = (interval) => {
        setTimeFilterSelections({
            ...timeFilterSelections, "timeInterval": interval
        });
    }

    return (
        <div className='time-filter-page-container'>
            <FlyoutMenu
                buttonSize="medium"
                customFooter={null}
                defaultOpen={false}
                direction="bottom-end"
                disabled={false}
                saveDisabled={(validEndDate || validStartDate || validEndTime) ? true : false}
                light
                i18n={{
                    applyButtonText: i18n.t('manageAutomation.Save'),
                    cancelButtonText: i18n.t('manageAutomation.Cancel')
                }}
                menuOffset={{
                    left: 0,
                    top: 0
                }}
                onApply={handleFilterChange}
                onCancel={handleFilterCancel}
                passive={false}
                label={Time}
                renderIcon={CalendarSettings32}
                tabIndex={0}
                toolTipClassName=""
                tooltipId="flyout-tooltip"
                triggerId="test-trigger-id-2"
                className="manage-automation-flyout-menu"
                hasIconOnly={true}
                kind={'ghost'}
                iconDescription={"Time Filter"}
            >
                <ContentSwitcher className='time-refresh-switcher' defaultSelected={timeRefreshIndex} onChange={handleTimeRefreshToggle}>
                    <Switch name="main1" text={Time} />
                    <Switch name="main2" text={Refresh} />
                </ContentSwitcher>
                <div id="main1" hidden={!timeRefreshContentShow1}>
                    <table className='time-buttons'>
                        <tr>
                            <td><Button kind="ghost" onClick={() => handleTimeButtonClick('15m')} >15m</Button></td>
                            <td><Button kind="ghost" onClick={() => handleTimeButtonClick('30m')}>30m</Button></td>
                            <td><Button kind="ghost" onClick={() => handleTimeButtonClick('1H')}>1H</Button></td>
                        </tr>
                        <tr>
                            <td><Button kind="ghost" onClick={() => handleTimeButtonClick('1D')} >1D</Button></td>
                            <td><Button kind="ghost" onClick={() => handleTimeButtonClick('7D')}>7D</Button></td>
                            <td><Button kind="ghost" onClick={() => handleTimeButtonClick('1M')}>1M</Button></td>
                        </tr>
                        <tr>
                            <td><Button kind="ghost" onClick={() => handleTimeButtonClick('3M')}>3M</Button></td>
                            <td><Button kind="ghost" onClick={() => handleTimeButtonClick('6M')}>6M</Button></td>
                            <td><Button kind="ghost" onClick={() => handleTimeButtonClick('1Y')}>1Y</Button></td>
                        </tr>
                    </table>
                    <ContentSwitcher className='date-custom-switcher' defaultSelected={timeFilterIndex} onChange={handleTimeFilterToggle}>
                        <Switch name="sub1" text={tillDate} />
                        <Switch name="sub2" text={Custom} />
                    </ContentSwitcher>
                    <div id="sub1" hidden={!timeFilterContentShow1}>
                        <FormGroup >
                            <RadioButtonGroup
                                legend="Group Legend"
                                name="timeTillDate"
                                onChange={handleTimeButtonClick}
                                defaultSelected={timeFilterSelections.timeRange}
                            >
                                <RadioButton className="manage-automation-timefilter-radiobutton" value="wtd" id="radio-1" labelText="WTD" />
                                <RadioButton className="manage-automation-timefilter-radiobutton" value="mtd" id="radio-2" labelText="MTD" />
                                <RadioButton className="manage-automation-timefilter-radiobutton" value="ytd" id="radio-3" labelText="YTD" />
                            </RadioButtonGroup>
                        </FormGroup>
                    </div>
                    <div id="sub2" className='timefilter-form-container' hidden={!timeFilterContentShow2}>
                        <table >
                            <tr>
                                <td><div className="time-filter-labels">{StartDate}</div>
                                    <DatePicker className="time-filter-date-picker" datePickerType="single" onChange={(e) => handleTimeChange('startDate', e)}
                                        maxDate={moment(new Date()).format("MM/DD/yyyy")}>
                                        <DatePickerInput
                                            placeholder="mm/dd/yyyy"
                                            id="date-picker-single"
                                            value={timeFilterSelections.startDate} />
                                    </DatePicker>
                                </td>
                            </tr>
                            <tr>
                                <td><div className="time-filter-labels">{StartTime}</div>
                                    <TimePicker id="time-picker" {...timeprops.timepicker()} value={timeFilterSelections.startTime} onBlur={(e) => handleTimeChange('startTime', e)} className={validStartDate ? "box-error" : ""}>
                                        <TimePickerSelect id="time-picker-select-1" value={timeFilterSelections.startAMPM} onChange={(e) => handleTimeChange('startAMPM', e)}>
                                            <SelectItem value="AM" text="AM" />
                                            <SelectItem value="PM" text="PM" />
                                        </TimePickerSelect>
                                    </TimePicker>
                                    {validStartDate && <div className='timepicker-custom-error'>{startTimeErrorMessage}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><div className="time-filter-labels">{EndDate}</div>
                                    <DatePicker datePickerType="single" onChange={(e) => handleTimeChange('endDate', e)}
                                        minDate={MinEndDate}
                                        maxDate={moment(new Date()).format("MM/DD/yyyy")}
                                    >
                                        <DatePickerInput
                                            placeholder="mm/dd/yyyy"
                                            id="date-picker-single"
                                            value={timeFilterSelections.endDate}
                                            invalid={validEndDate}
                                        />
                                    </DatePicker>
                                </td>
                            </tr>
                            <tr>
                                <td><div className="time-filter-labels">{EndTime}</div>
                                    <TimePicker id="time-picker" {...timeprops.timepicker()} value={timeFilterSelections.endTime} onBlur={(e) => handleTimeChange('endTime', e)} className={validEndDate ? "box-error" : ""}>
                                        <TimePickerSelect id="time-picker-select-1" value={timeFilterSelections.endAMPM} onChange={(e) => handleTimeChange('endAMPM', e)}>
                                            <SelectItem value="AM" text="AM" />
                                            <SelectItem value="PM" text="PM" />
                                        </TimePickerSelect>
                                    </TimePicker>
                                    {(validEndDate || validEndTime) && <div className='timepicker-custom-error'>{endTimeErrorMessage}</div>}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>

                <div id="main2" hidden={!timeRefreshContentShow2}>
                    <table className='time-buttons' style={{

                        justifyContent: 'center',
                        width: '100%'
                    }}>
                        <tr>
                            <td align='center'><Button kind="ghost" onClick={() => updateRefresh(10000)} >10 sec</Button></td>
                        </tr>
                        <tr><td align='center'><Button kind="ghost" onClick={() => updateRefresh(60000)}>1 min</Button></td></tr>
                        <tr><td align='center'><Button kind="ghost" onClick={() => updateRefresh(300000)}>5 mins</Button></td></tr>
                        <tr><td align='center'><Button kind="ghost" onClick={() => updateRefresh(0)}>Off</Button></td></tr>
                    </table>
                </div>
            </FlyoutMenu>
        </div>
    );
};
export default TimeFilter;
